export default class SplitLines
{
    constructor(elem)
    {
        this.elem = elem
        this.text = this.elem.innerText
        this.lines = []
        this.wrappedLines = []

        this.initSplit()
    }

    initSplit()
    {
        this.lines = this.text.split(/\r?\n/g)
        // console.log('splitted lines', this.lines)

        for(let i = 0; i < this.lines.length; i++)
        {
            const line = this.lines[i]
            if(line.length > 0)
            {
                const html = '<div class="splitted-line"><span class="splitted-line__inner">' + line + '</span></div>'
                this.wrappedLines.push(html)
            }
        }

        // console.log('wrapped lines', this.wrappedLines)

        this.elem.innerHTML = this.wrappedLines.join(' ')
    }
}